var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',{staticClass:"banner-popup",attrs:{"id":_vm.instanceId,"module-name":"BannerPopup","data-module":"banner-popup","show-on-desk":_vm.showOnDesk,"show-on-mobile":_vm.showOnMobile}},[_c('EditorLink',{attrs:{"model":_vm.linkUrl}},[_c('LImage',{attrs:{"src":_vm.image,"alt":_vm.imageAlt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }